import * as Yup from 'yup';

export default Yup.object().shape({
  statementOfCircumstances: Yup.string(),
});
